// AJ Coordinates (10 Oct 2026) – tidies the Wayfinder map on the coordinates products.
// Wayfinder still draws the map, runs the search and works out the coordinates (it writes them into
// #map-feedback-DMS). This script shows them under the map with one button that writes them into the AVIS
// engraving field, so the customer does not have to copy and paste. Wayfinder's own "Confirm location"
// button is hidden and never used: it only greyed the map out, and it could also pre-fill the checkout
// address with the engraved place.
//
// The engraving fields are found by their AVIS option keys (the same in every language), never by label:
//   pendants  – the coordinates field;
//   four-side bars (PRISM, MINIMAL) – front / left-or-top / right-or-bottom / back: the customer picks one.
// If no known field is on the page, the button copies the coordinates instead.
// Texts come from snippets/aj-coordinates.liquid; styles are in assets/aj-coordinates.css.
(function () {
  if (window.AJCoordinates) return;
  window.AJCoordinates = true;

  var COORD_KEYS = ['Hcye42TOcLBpxh3lzvxhNqUK1bUmNR', 'cZXHC9u9z3PjxFtf235nx-m55AjU2j'];
  var BAR_ONLY_KEYS = ['-0XNY4-lEihc_Lq314xma3jXvTvez6', 'F0c2mJDVTjKUbvAtD9MMuP60PHI7fu'];
  var BAR_KEYS = ['Hcye42TOcLBpxh3lzvxhNqUK1bUmNR', '-0XNY4-lEihc_Lq314xma3jXvTvez6', 'F0c2mJDVTjKUbvAtD9MMuP60PHI7fu', 'rLGAELSb8gI4mTuuUGw46UAxEa6yWp'];

  var intro = document.querySelector('[data-aj-coordinates]');
  if (!intro) return;
  var t = intro.dataset;
  var panel, value, useButton, sides, sidesList, done, current = '';

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function optionBox(key) {
    var root = document.getElementById('avpoptions-container__v2');
    return root ? root.querySelector('.ap-options__text-container[key="' + key + '"]') : null;
  }

  function option(key) {
    var box = optionBox(key);
    var input = box && box.querySelector('input[type="text"]');
    return input && box.offsetHeight ? { box: box, input: input } : null;
  }

  // The engraving fields the coordinates may go into, as they are on the page right now
  function targets() {
    var isBar = BAR_ONLY_KEYS.some(optionBox);
    return (isBar ? BAR_KEYS : COORD_KEYS).map(option).filter(Boolean);
  }

  function fill(target) {
    var input = target.input;
    var text = current;
    if (input.maxLength > 0 && text.length > input.maxLength) text = text.slice(0, input.maxLength);
    Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(input, text);
    ['input', 'change', 'keyup'].forEach(function (type) { input.dispatchEvent(new Event(type, { bubbles: true })); });
    input.classList.add('aj-coord-filled');
    setTimeout(function () { input.classList.remove('aj-coord-filled'); }, 2500);
    show('done', t.added);
  }

  function show(state, doneText) {
    panel.dataset.state = state;
    value.textContent = current || t.empty;
    useButton.hidden = state !== 'empty' && state !== 'ready';
    useButton.disabled = state === 'empty';
    sides.hidden = state !== 'sides';
    done.hidden = state !== 'done';
    if (doneText) done.firstChild.textContent = doneText;
  }

  function use() {
    if (!current) return;
    var list = targets();
    if (!list.length) {
      // no known engraving field: copy instead
      var copied = function () { show('done', t.copied); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(current).then(copied, copied);
      else copied();
      return;
    }
    if (list.length === 1) { fill(list[0]); return; }
    sidesList.textContent = '';
    list.forEach(function (target) {
      var title = target.box.querySelector('.apo-title');
      var button = el('button', 'aj-coord__button', title ? title.textContent.trim() : '');
      button.type = 'button';
      button.addEventListener('click', function () {
        var fresh = option(target.box.getAttribute('key'));
        if (fresh) fill(fresh);
      });
      sidesList.appendChild(button);
    });
    show('sides');
  }

  // Wayfinder writes  38° 41' 29.76'' N | 9° 12' 57.6'' W ; the shop engraves  38°41'29.76"N 9°12'57.60"W
  // (no spaces inside, no bar, seconds with two decimals) – owner's choice, 10 Oct 2026.
  function engravingFormat(text) {
    var part = /(\d+)\s*°\s*(\d+)\s*'\s*([\d.]+)\s*(?:''|")\s*([NSEW])/g;
    var out = [];
    var m;
    while ((m = part.exec(text))) out.push(m[1] + '°' + m[2] + "'" + Number(m[3]).toFixed(2) + '"' + m[4]);
    if (out.length === 2) return out.join(' ');
    // not the shape we know: only tidy it (no bar, single spaces)
    return text.replace(/\s*\|\s*/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function read(dms) {
    var text = engravingFormat(dms.textContent.replace(/\s+/g, ' ').trim());
    if (text === current) return;
    current = text;
    useButton.textContent = targets().length ? t.use : t.copy;
    show(current ? 'ready' : 'empty');
  }

  function init() {
    var box = document.getElementById('MapContainer');
    var map = document.getElementById('map');
    var dms = document.getElementById('map-feedback-DMS');
    if (!box || !map || !dms) return false;

    panel = el('div', 'aj-coord');
    var info = el('div');
    info.appendChild(el('div', 'aj-coord__label', t.label));
    value = el('div', 'aj-coord__value');
    info.appendChild(value);
    useButton = el('button', 'aj-coord__button', t.use);
    useButton.type = 'button';
    useButton.addEventListener('click', use);
    sides = el('div', 'aj-coord__sides');
    sides.appendChild(el('div', 'aj-coord__sides-title', t.choose));
    sidesList = el('div', 'aj-coord__sides-list');
    sides.appendChild(sidesList);
    done = el('div', 'aj-coord__done');
    done.appendChild(document.createTextNode(''));
    var change = el('button', 'aj-coord__change', t.change);
    change.type = 'button';
    change.addEventListener('click', function () {
      show(current ? 'ready' : 'empty');
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    done.appendChild(change);
    [info, useButton, sides, done].forEach(function (node) { panel.appendChild(node); });
    map.insertAdjacentElement('afterend', panel);

    var search = document.getElementById('pac-input');
    if (search && t.search) search.placeholder = t.search;

    document.documentElement.classList.add('aj-coord-on');
    show('empty');
    read(dms);
    new MutationObserver(function () { read(dms); }).observe(dms, { childList: true, characterData: true, subtree: true });
    // the map box changed size: let the map redraw its tiles
    window.dispatchEvent(new Event('resize'));
    return true;
  }

  // Owner's wish (10 Oct): the birthstones choice right after the chain, and the map right above the field the
  // coordinates go into. The birthstones are AVIS options inside the product form, so the heading and the map
  // are moved into AVIS's list, right after the birthstone options (AVIS draws its options once and only
  // shows / hides them afterwards, so the moved blocks stay put). Inside the form nothing of the map may be
  // sent with the order or submit the form: Wayfinder's own named field is switched off and its buttons are
  // made plain buttons. Block setting "Show the map after the birthstones choice" turns this off.
  var STONE_KEYS = ['--5QmbFN9KZSsoDFzzvFbIUwPoNHvK', '3wJoDuhgV4DY9xv_RtAClMqrOZpnzD'];
  function relocate() {
    if (t.afterBirthstones !== 'true') return true;
    var root = document.getElementById('avpoptions-container__v2');
    if (!root || !root.querySelector('.avp-option')) return false;
    var stones = [].filter.call(root.children, function (node) {
      return STONE_KEYS.indexOf(node.getAttribute('key')) > -1 || node.querySelector('.ap-swatch__multi');
    });
    var introItem = intro.closest('.product-info__block-item');
    var mapBox = document.getElementById('MapAppContainer');
    var mapItem = mapBox && mapBox.closest('.product-info__block-item');
    if (!stones.length || !introItem || !mapItem) return true;
    mapItem.querySelectorAll('[name]').forEach(function (field) { field.disabled = true; field.removeAttribute('name'); });
    mapItem.querySelectorAll('button:not([type])').forEach(function (button) { button.type = 'button'; });
    var holder = el('div', 'aj-coord-moved');
    stones[stones.length - 1].insertAdjacentElement('afterend', holder);
    holder.appendChild(introItem);
    holder.appendChild(mapItem);
    window.dispatchEvent(new Event('resize'));
    return true;
  }
  function start() {
    if (!init()) return false;
    var moves = 0;
    var mover = setInterval(function () { if (relocate() || ++moves > 100) clearInterval(mover); }, 300);
    return true;
  }

  // Wayfinder draws its block a little after the page
  if (start()) return;
  var tries = 0;
  var timer = setInterval(function () { if (start() || ++tries > 100) clearInterval(timer); }, 300);
})();
